var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 4.84375C9.4375 5.83203 9.11523 6.75586 8.57812 7.48633L10.9414 9.87109L11.4355 10.3438L10.4688 11.332L9.97461 10.8379L7.58984 8.45312C6.85938 9.01172 5.93555 9.3125 4.96875 9.3125C2.49805 9.3125 0.5 7.31445 0.5 4.84375C0.5 2.39453 2.49805 0.375 4.96875 0.375C7.41797 0.375 9.4375 2.39453 9.4375 4.84375ZM4.96875 7.9375C6.06445 7.9375 7.07422 7.35742 7.63281 6.39062C8.19141 5.44531 8.19141 4.26367 7.63281 3.29688C7.07422 2.35156 6.06445 1.75 4.96875 1.75C3.85156 1.75 2.8418 2.35156 2.2832 3.29688C1.72461 4.26367 1.72461 5.44531 2.2832 6.39062C2.8418 7.35742 3.85156 7.9375 4.96875 7.9375Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1ad04e1a7a20e3c45c91b25a19c9c2da.svg";
export { ForwardRef as ReactComponent };